import React from 'react';
import { Bar } from './SkeletonBar';

// Rows for the HistoryPage feed list — source line, title, timestamp,
// thumbnail and status chip, matching the real row anatomy.
const HistoryRowsSkeleton = () => (
  <>
    {Array.from({ length: 5 }).map((_, i) => (
      <div key={i} className="flex gap-3 px-4 py-3.5">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <Bar className="w-5 h-5 shrink-0 rounded-[6px]" />
            <Bar className="h-3 w-16" />
          </div>
          <Bar className="mt-2.5 h-3.5 w-4/5" />
          <Bar className="mt-2 h-2.5 w-28" />
        </div>
        <div className="shrink-0 flex flex-col items-end justify-between">
          <Bar className="w-[60px] h-[60px] rounded-lg" />
          <Bar className="mt-2 h-4 w-12" />
        </div>
      </div>
    ))}
  </>
);

export default HistoryRowsSkeleton;
